import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private cacheData: { [key: string]: { subject: ReplaySubject<any>; expiration: number } } = {};

  getOrSetCache<T>(key: string, fetchData: Observable<T>, ttl = 300000 /* 5 minutes */): Observable<T> {
    const now = Date.now();

    if (this.cacheData[key] && this.cacheData[key].expiration > now) {
      return this.cacheData[key].subject.asObservable();
    }

    this.cacheData[key] = {
      subject: new ReplaySubject<T>(1),
      expiration: now + ttl,
    };

    fetchData.subscribe(
      data => this.cacheData[key].subject.next(data),
      error => this.cacheData[key].subject.error(error),
      () => this.cacheData[key].subject.complete()
    );

    return this.cacheData[key].subject.asObservable();
  }
}
